import { useIsExistingCustomer } from 'hooks/common/use-is-existing-customer';
import useMobile from 'hooks/common/use-mobile';
import { AI_WEIGHT_ENABLED } from 'modules/ai-weight-analyzer/constants';
import { isAiWeightSuppressed, useAiWeightAnalyzerStore } from 'stores/ai-weight-analyzer';

export const useAiWeightIsVisible = (): boolean => {
  const isMobile = useMobile();
  const { isEc } = useIsExistingCustomer();
  const engagedAt = useAiWeightAnalyzerStore((state) => state.engagedAt);
  return AI_WEIGHT_ENABLED && isMobile && !isEc && !isAiWeightSuppressed(engagedAt);
};
